export default __webpack_public_path__ + "static/media/back.61cc11ad.svg";